import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Select } from '@salt/components';
import { getReports } from '../../api/reports';
import { getLocations, getProjects } from '../../api/users';
import BetaReportsScreen from './BetaReportsScreen';
// import FilterIcon from '../media/icons/filter.svg';
import { hostname } from '../../api/util';

const PAGE_SIZE = 100;

const ReportsScreen = () => {
  const ws = useRef(null);

  const [reports, setReports] = useState([]);
  const [projects, setProjects] = useState([]);
  const [locations, setLocations] = useState([]);
  // eslint-disable-next-line sonarjs/no-dead-store, no-unused-vars, sonarjs/sonar-no-unused-vars
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState();

  // eslint-disable-next-line sonarjs/no-dead-store, sonarjs/sonar-no-unused-vars, no-unused-vars
  const [mapFilters, setMapFilters] = useState('reports,users');
  // const [heatmap, setHeatmap] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { reportItems } = await getReports({
        page: 0,
        limit: PAGE_SIZE,
        keywords: '',
      });

      const { projectItems } = await getProjects({ limit: 1000 });
      const { locationsItems } = await getLocations();

      setReports(reportItems);
      setLocations(locationsItems);
      // setTotal(reportTotalItems);
      setProjects(projectItems);
    } catch (error) {
      console.error(error.message);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const setup = async () => {
      setLoading(true);
      try {
        ws.current = new EventSource(`${hostname}/api/portal/sse`);
        ws.current.onopen = () => console.debug('sse opened');
        ws.current.onclose = () => console.debug('sse closed');

        ws.current.addEventListener('location', (e) => {
          const data = JSON.parse(e.data);
          console.log('a user location updated', data);
          setUpdate(data);
        });

        ws.current.addEventListener('report', (msg) => {
          setUpdate(msg);
        });
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    };

    setup();

    const wsCurrent = ws?.current;

    return () => {
      wsCurrent.close();
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [update]);

  const handleMapFilterChange = useCallback(
    (newVal) => {
      let tmpVal = (mapFilters?.length > 0 && mapFilters?.split(',')) || [];
      if (tmpVal.includes(newVal)) {
        tmpVal = tmpVal.filter((v) => v !== newVal);
      } else {
        tmpVal.push(newVal);
      }
      setMapFilters(tmpVal.join(','));
    },
    [mapFilters]
  );

  return (
    <main
      style={{
        width: 'calc(100% - 460px)',
        padding: '0',
      }}
    >
      <div className="z-40 drop-shadow-md absolute left-6 top-[25px]">
        <Select
          icon="filter"
          onClick={handleMapFilterChange}
          width="w-[190px]"
          labelBackgroundClass="group-focus:bg-secondary"
          backgroundClass="bg-secondary-light"
          multiSelect
          customRenderValue={() => 'Reports/Users'}
          renderItems={[
            {
              id: 'reports',
              render: () => {},
              value: 'Reports',
            },
            {
              id: 'users',
              render: () => {},
              value: 'Users',
            },
          ]}
          value={mapFilters}
        />
      </div>

      <BetaReportsScreen
        reports={reports}
        projects={projects}
        locations={locations}
        mapFilters={mapFilters} /* heatmap={heatmap} */
      />
    </main>
  );
};

export default ReportsScreen;
